/**
 * XP Services Facade
 *
 * Public API for all XP-related functionality
 * - XP awarding and tracking (XpService)
 */

import { supabase } from '../database';
import { XpService } from './xp.service';

// Initialize service with dependency injection
const xpService = new XpService(supabase);

/**
 * Export initialized service instance (use this in application code)
 */
export { xpService };

/**
 * Export service class (for testing and DI)
 */
export { XpService };

/**
 * Export milestone checker functions
 */
export {
  checkMilestones,
  getAchievedMilestones,
  getAchievedCount,
  isMilestoneAchieved,
} from './milestone-checker';
